module.exports = __webpack_public_path__ + "static/logo-262821148e68913f812f67373db26010.svg";